<template>

  <v-card height="640" class="mt-0" flat>
    <KYCCompany
      v-if="currentClient.ClientTypeID == 1"
      :allComDocuments="allComDocuments"
      :currentClient="currentClient"
      :existingRecord="Company"
    />
    <KYCPartnership
      v-if="currentClient.ClientTypeID == 2"
      :allParDocuments="allParDocuments"
      :currentClient="currentClient"
      :existingRecord="Partnership"
    />
    <KYCPension
      v-if="currentClient.ClientTypeID == 3"
      :allPenDocuments="allPenDocuments"
      :currentClient="currentClient"
      :existingRecord="Pension"
    />
    <KYCTrust
      v-if="currentClient.ClientTypeID == 4"
      :allTruDocuments="allTruDocuments"
      :currentClient="currentClient"
      :existingRecord="Trust"
    />
    <KYCDeceasedEstate
      v-if="currentClient.ClientTypeID == 5"
      :allDecDocuments="allDecDocuments"
      :currentClient="currentClient"
      :existingRecord="DeceasedEstate"
    />
    <KYCIndividual
      v-if="currentClient.ClientTypeID == 6"
      :allIndDocuments="allIndDocuments"
      :currentClient="currentClient"
      :existingRecord="Individual"
    />
  </v-card>
</template>

<script>
import {mapGetters} from "vuex";
import KYCCompany from './KYCCompany';
import KYCDeceasedEstate from './KYCDeceasedEstate';
import KYCIndividual from './KYCIndividual';
import KYCPartnership from './KYCPartnership';
import KYCPension from './KYCPension';
import KYCTrust from './KYCTrust';
// import UserService from '../services/user.service';

export default {

  components: {
    KYCCompany,
    KYCDeceasedEstate,
    KYCIndividual,
    KYCPartnership,
    KYCPension,
    KYCTrust
  },

  data () {
    return {
      valid: true,
      changeFile: false,
      Doc: {},
    }
  },

  props: ['currentClient'],

  computed: {
    ...mapGetters([
      "allComDocuments",
      "allDecDocuments",
      "allIndDocuments",
      "allParDocuments",
      "allPenDocuments",
      "allTruDocuments"
    ]),

    Company(){
      return this.allComDocuments.map(a => a.ClientId).includes(this.currentClient.ClientID)
    },

    DeceasedEstate(){
      return this.allDecDocuments.map(a => a.ClientId).includes(this.currentClient.ClientID)
    },

    Individual(){
      return this.allIndDocuments.map(a => a.ClientId).includes(this.currentClient.ClientID)
    },

    Partnership(){
      return this.allParDocuments.map(a => a.ClientId).includes(this.currentClient.ClientID)
    },

    Pension(){
      return this.allPenDocuments.map(a => a.ClientId).includes(this.currentClient.ClientID)
    },

    Trust(){
      return this.allTruDocuments.map(a => a.ClientId).includes(this.currentClient.ClientID)
    },

    currentUser() {
      return this.$store.state.auth.user;
    },
  },

  methods: {
    showEditBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 302).map(r => r.AllowEdit)) == 1){
        return true
      }
    }
    return false;
    },

    showCreateBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 302).map(r => r.AllowCreate)) == 1){
        return true
      }
    }
    return false;
    },

    showConfirmBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 302).map(r => r.AllowConfirm)) == 1){
        return true
      }
    }
    return false;
    },
  },
}
</script>
